import {Component, ElementRef, Input, OnInit, ViewChild, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-cs-signature-generator',
  templateUrl: './cs-signature-generator.component.html',
  styles: []
})

export class CsSignatureGeneratorComponent implements OnInit {

    @ViewChild("canvasEl") canvasEl: ElementRef;
    public base64Image = "";
    private context: CanvasRenderingContext2D;
    private currentIndex: number = -1;

    @Input() signatureText = 'Commusoft';
    @Input() dataSource: any[] = dataSource;
    @Input() imageHeight: string = "200";
    @Input() imageWidth: string = "200";
    @Input() showSignature: boolean = false;
    @Output() signatureAsBase64: EventEmitter<any> = new EventEmitter<any>();

    constructor() {}

    ngOnInit(){}

    ngAfterViewInit() {}

    onSignatureSelection(data, index) {
      this.currentIndex = index;
      this.generateSignature(data.FontSize, data.FontFamily, data.FontWeight);
    }

    private generateSignature(fontSize: string, fontFamily: string, fontWeight: string) {
        this.context = (this.canvasEl
            .nativeElement as HTMLCanvasElement).getContext("2d");
        this.context.font = ` ${fontSize} ${fontFamily}`;
        this.context.textBaseline = "middle";
        this.context.textAlign = "center";
        this.context.imageSmoothingQuality = "high";
        this.context.imageSmoothingEnabled = true;
        this.context.lineWidth = 15;
        this.context.fillStyle = "black";
        const x = (this.canvasEl.nativeElement as HTMLCanvasElement).width / 2;
        const y = (this.canvasEl.nativeElement as HTMLCanvasElement).height / 2;
        this.context.fillText(this.signatureText, x, y);
        if (this.context) {
            this.base64Image = (this.canvasEl
                .nativeElement as HTMLCanvasElement).toDataURL("image/png");
            const canvasWidth = (this.canvasEl.nativeElement as HTMLCanvasElement)
                .width;
            const canvasHeight = (this.canvasEl.nativeElement as HTMLCanvasElement)
                .height;
            this.context.clearRect(0, 0, canvasWidth, canvasHeight);
            this.signatureAsBase64.emit(this.base64Image);
        }
    }
}

const dataSource = [
    {
        FontFamily: "Sacramento",
        FontSize: "30px",
        FontWeight: "bold"
    },
    {
        FontFamily: "Satisfy",
        FontSize: "30px",
        FontWeight: "bold"
    },
    {
        FontFamily: "Pacifico",
        FontSize: "30px",
        FontWeight: "bold"
    },
    {
        FontFamily: "Gloria Hallelujah",
        FontSize: "30px",
        FontWeight: "bold"
    },
    {
        FontFamily: "Lobster",
        FontSize: "30px",
        FontWeight: "bold"
    },
    {
        FontFamily: "Dancing Script",
        FontSize: "30px",
        FontWeight: "bold"
    },
];
